import { Button, IMenuItemProps, Menu, MenuItem, Popover, Intent, Tag} from "@blueprintjs/core";
import { IconNames } from '@blueprintjs/icons';
import { Fragment } from "core/components/FragmentProvider";
import React from "react";

import Label from "core/components/label/Label";
import TokenSession from "../../../../core/util/session/TokenSession";
import Topic from "../../entity/Topic";
import * as forumActions from '../../forumActions';
import { SubscriptionsPopover } from "../subscriptions/SubscriptionsPopover";
import { ITopicComponentProps, ITopicFragmentProps } from "./TopicComponent";
import TopicDisplayMode from "./TopicDisplayMode";
import styled from "styled-components";
import  TopicFeatureComponent from "panels/forum/component/topic/TopicFeatureComponent";

const SmallPadding = styled.div`
	padding-left: 10px;
	padding-bottom: 5px;
	display: inline-block;
`;

export const Upvote: Fragment<ITopicFragmentProps> = {
	name: "Upvote",
	enabled: ({ topic }) => topic.stats != null,
	component: ({ config, topic, actions }) => (
		<Button icon={IconNames.THUMBS_UP} onClick={() => {
			forumActions.upvoteTopic(topic)
			actions.getTopicVote(topic)
		}}>
			{topic.stats.votePositive}
		</Button>
	)
};

export const Downvote: Fragment<ITopicFragmentProps> = {
	name: "Downvote",
	enabled: ({ topic }) => topic.stats != null,
	component: ({ config, topic, actions }) => (
		<Button icon={IconNames.THUMBS_DOWN} onClick={() => {
			forumActions.dowvoteTopic(topic)
			actions.getTopicVote(topic)
		}}>
			{topic.stats.voteNegative}
		</Button>
	)
};
export const Bookmark: Fragment<ITopicFragmentProps> = {
	name: "bookmark",
	component: ({config, topic, actions}) => (
		<React.Fragment>
			{topic.bookmark && topic.bookmark.bookmarked
			? <Button icon={IconNames.FLAG} onClick={() => {
				forumActions.bookmarkTopic(topic)
				actions.bookmark(topic)
			}}/>
			: <Button icon={IconNames.BOOKMARK} onClick={() => {
				forumActions.bookmarkTopic(topic)
				actions.bookmark(topic)
			}}/>
		}
		</React.Fragment>
	)
};

const ReportMenu: React.SFC<{ topic: Topic, onClick: () => void }> = ({ topic, onClick }) => {

	// TODO get these from a service
	const reportActions: IMenuItemProps[] = [
		{
			text: <Label k={"report.confidential"} v="Confidential" />,
			onClick: () => forumActions.flagTopic(topic, "confidential").then(() => onClick())
		},
		{
			text: <Label k={"report.inappropriate"} v="Inappropriate" />,
			onClick: () => forumActions.flagTopic(topic, "inappropriate").then(() => onClick())
		}
	];

	const items = reportActions.map((item, index) => (
		<MenuItem key={index} {...item} />
	));

	return (
		<Menu>
			{items}
		</Menu>
	);

};

class ReportPopover extends React.Component<ITopicFragmentProps, { reported: boolean }> {

	constructor(props) {
		super(props);
		this.state = { reported: false };
	}

	public render() {
		const { topic } = this.props;
		const { reported } = this.state;

		return (
			<Popover
				content={<ReportMenu topic={topic} onClick={() => this.setState({ reported: true })} />}
				disabled={reported}
			>
				<Button icon={IconNames.CARET_DOWN} disabled={reported}>
					<Label k="topic.report" v="Report" />
				</Button>
			</Popover>
		);
	}

}

export const Report: Fragment<ITopicFragmentProps> = {
	name: "Report",
	component: ReportPopover
};

export const Reply: Fragment<ITopicFragmentProps> = {
	name: "Reply",
	enabled: ({ currentDepth, listConfig }) => currentDepth < listConfig.maxDepth,
	component: ({ config, topic, actions, mode, replyActive }) => (
		<Button
			icon={IconNames.EDIT}
			onClick={() => TopicDisplayMode.OVERVIEW === mode ? actions.navigateTo(true) : actions.reply()}
			disabled={replyActive}
		>
			<Label k="topic.reply" v="Reply" />
		</Button>
	)
};

export const Replies: Fragment<ITopicFragmentProps> = {
	name: "Replies",
	enabled: ({ mode }) => TopicDisplayMode.OVERVIEW === mode,
	component: ({ config, topic, actions }) => (
		<Button onClick={() => actions.navigateTo()}>
			<Label k="topic.reply" v="${count} Replies" args={{ count: !!topic.stats && topic.stats.replies || 0 }} />
		</Button>
	)
};

export const Subscriptions: Fragment<ITopicFragmentProps> = {
	name: "Follow",
	component: ({ topic }) => (
		<SubscriptionsPopover topic={topic} />
	)
};

export const Edit: Fragment<ITopicFragmentProps> = {
	name: "Edit",
	enabled: ({ topic }) => topic.createdBy && topic.createdBy.id === TokenSession.getUserId(),
	component: ({ config, topic, actions }) => (
		<Button icon={IconNames.EDIT} onClick={() => actions.edit(true)}>
			<Label k="topic.edit" v="Edit" />
		</Button>
	)
};

export const Feature: Fragment<ITopicFragmentProps> = {
	name: "Feature",
	enabled: ({ topic }) => TokenSession.hasRoles("ROLE_ADMIN","ROLE_SADMIN","ROLE_CONTEXT_EDITOR"),
	component: ({ config, topic, actions }) => {
		return (
			<TopicFeatureComponent topic={{...topic}}/>
		);
	}
};


export const Tags: Fragment<ITopicFragmentProps> = {
	name: "Tags",
	enabled: ({ tagsEnabled }) => tagsEnabled,
	component: ({ config, topic, actions }) => {
		const tags = topic.tagEntities && topic.tagEntities.length
			&& topic.tagEntities.map(t=><SmallPadding><Tag key={t.id}>{t.name}</Tag></SmallPadding>);
		if(!tags)
			return (<React.Fragment />);
		return (<React.Fragment>
					<div ><Label k="topic.tags" v="Tags" />:{tags}</div>
				</React.Fragment>);;
	}
};



// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/topicActions.tsx